// Google Analytics 4 (gtag.js) — loaded only when REACT_APP_GA_MEASUREMENT_ID is set.
// GA4's `config` fires a pageview only on initial load, so in this SPA we fire
// page_view manually on every route change (see trackPageview / usePageviews).

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const gaEnabled = Boolean(GA_ID);

export function initGA(): void {
  if (!GA_ID || window.gtag) return; // no-op when disabled or already loaded

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js only processes `arguments` objects — a plain array (e.g. from
    // rest params) is silently ignored and no hits are ever sent.
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  // send_page_view: false — we fire page_view ourselves on each route change.
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageview(path: string): void {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
  });
}

export function identifyGA(userId: string): void {
  if (!GA_ID || !window.gtag) return;
  window.gtag("config", GA_ID, { user_id: userId, send_page_view: false });
}
